// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"tooltipWrapper__MTA4N"};